//#region src/punchh_olo_slug.ts
var PunchhOloSlug = /* @__PURE__ */ function(PunchhOloSlug) {
	PunchhOloSlug["Punchh"] = "punchh";
	PunchhOloSlug["PunchhProduction"] = "punchh-production";
	PunchhOloSlug["PunchhMs"] = "punchhms";
	return PunchhOloSlug;
}(PunchhOloSlug || {});
//#endregion
export { PunchhOloSlug };

//# sourceMappingURL=punchh_olo_slug.js.map